import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  subHeading: {
    color: theme.palette.text.secondary,
    fontSize: '18px',
    fontWeight: 600,
    marginRight: theme.spacing(1.125),
  },
  infoIcon: {
    color: theme.palette.icon.main,
    marginTop: theme.spacing(0.75),
    '&.MuiSvgIcon-root': {
      height: '16px',
      width: '16px',
    },
  },
  textField: {
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      display: 'none',
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
    '& .MuiInputBase-input': {
      fontSize: '13px',
      color: theme.palette.black.main,
      textAlign: 'left',
      padding: '6px 0px 12px 0px !important',
    },
    '& .Mui-disabled': {
      color: theme.palette.labraText.primary,
      '-webkit-text-fill-color': `${theme.palette.labraText.primary} !important`,
    },
    '& .MuiInputLabel-root': {
      fontSize: '13px',
      color: theme.palette.primary.light,
      fontWeight: 600,
      '&.Mui-disabled': {
        color: theme.palette.labraText.description,
        '-webkit-text-fill-color': `${theme.palette.labraText.description} !important`,
      },
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontSize: '11px',
      color: `${theme.palette.error.main} !important`,
    },
    '& .MuiFormLabel-asterisk.MuiInputLabel-asterisk': {
      color: theme.palette.requiredAsterisk.main,
    },
  },
  subHeadingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  companyDetailSubHead: {
    marginBottom: theme.spacing(2),
  },
  updateRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    gap: '24px',
    flexWrap: 'wrap',
  },
  closeIconButton: {
    padding: theme.spacing(0),
    margin: theme.spacing(-2.5, 0, -3, 0.187),
  },
  recipientsRowsContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  addButtonContainer: {
    margin: theme.spacing(3, 0, 0, 0),
    textAlign: 'left',
  },
}))
